import api from 'api';

export const loadApplications = api(
  'GET /api/players-activities/players-information/filters/applications'
);
export const loadAllEvents = api(
  'GET /api/players-activities/players-information/filters/events'
);
export const loadRegularEvents = api(
  'GET /api/players-activities/players-information/filters/events/regular'
);
export const loadRecurrentEvents = api(
  'GET /api/players-activities/players-information/filters/events/recurrent'
);
export const loadBusinessPartners = api(
  'GET /api/players-activities/players-information/filters/business-partners'
);

export const loadApplicationsWithEvents = api(
  'GET /api/players-activities/players-information/filters/applications-with-events'
);

export const loadPromoCodes = api(
  'GET /api/players-activities/players-information/filters/promocodes'
);
